import { QuoteType } from '@models/quotes';
import { AttributeType, PanelInstance, RuleEngine } from '@store/Quote/Quote.types';
import { PolicyCoverages } from '@models/insuranceLine';
import {
  professionalLiabilityBusinessClasses,
  professionalLiabilityLocations,
} from '../../../components/quoteDetails/QuoteDetails.constants';

export const getProfessionalLiabilitySideEffectValue = (params: {
  professionalLiabilityAttributeType: AttributeType;
  attributeTypeCodeName: string;
  newValue: string;
  productOption?: string;
  jurisdictions: string[];
  quoteItem: any;
  panelInstance: PanelInstance;
}): any | undefined => {
  const {
    professionalLiabilityAttributeType,
    attributeTypeCodeName,
    newValue,
    productOption,
    jurisdictions,
    quoteItem,
    panelInstance,
  } = params;

  if (
    productOption &&
    professionalLiabilityBusinessClasses.includes(productOption) &&
    jurisdictions.filter((value: any) => professionalLiabilityLocations.includes(value)).length === 0
  ) {
    const LOIProfessionalLiabilityValueId =
      professionalLiabilityAttributeType.attribute?.id ?? `${quoteItem.id}-${professionalLiabilityAttributeType.id}`;

    return {
      attributeId: LOIProfessionalLiabilityValueId,
      codeName: attributeTypeCodeName,
      panelInstanceId: panelInstance.panelInstanceId,
      update: {
        value: newValue,
        isLocked: professionalLiabilityAttributeType.attribute?.isLocked ?? null,
        valueOverride: professionalLiabilityAttributeType.attribute?.valueOverride ?? null,
      },
    };
  }
  return undefined;
};

export const getExcessLOIIndSideEffectValue = (params: {
  excessLOIIndAttributeType: AttributeType;
  attributeTypeCodeName: string;
  newValue: any;
  quoteType?: string;
  ruleEngine?: RuleEngine;
  quoteItem: PanelInstance['quoteItem'];
  panelInstance: PanelInstance;
  disabledPolicyCoverages: PolicyCoverages;
}): any | undefined => {
  const {
    excessLOIIndAttributeType,
    attributeTypeCodeName,
    newValue,
    quoteType,
    ruleEngine,
    quoteItem,
    panelInstance,
    disabledPolicyCoverages,
  } = params;
  if (
    excessLOIIndAttributeType &&
    !excessLOIIndAttributeType?.attribute?.value === newValue &&
    quoteType === QuoteType.NewBusiness
  ) {
    const excessLiabilitySelectionIsDisabled = disabledPolicyCoverages?.LOIExcessLiabilityInd;
    if (excessLiabilitySelectionIsDisabled) {
      return undefined;
    }
    if (!ruleEngine) {
      return undefined;
    }
    ruleEngine.setEngineInitialQuoteItemToPolicy();
    const excessIsActive = ruleEngine.execute(excessLOIIndAttributeType.isActive);
    const excessIsVisible = ruleEngine.execute(excessLOIIndAttributeType.isVisible);
    if (!excessIsActive || !excessIsVisible) {
      return undefined;
    }
    const excessAttributeValueId =
      excessLOIIndAttributeType.attribute?.id ?? `${quoteItem.id}-${excessLOIIndAttributeType.id}`;

    return {
      attributeId: excessAttributeValueId,
      codeName: attributeTypeCodeName,
      panelInstanceId: panelInstance.panelInstanceId,
      update: {
        value: newValue,
        isLocked: excessLOIIndAttributeType.attribute?.isLocked ?? null,
        valueOverride: excessLOIIndAttributeType.attribute?.valueOverride ?? null,
      },
    };
  }
  return undefined;
};
